import Vue from 'vue'
import axios from 'axios'
import VueRouter from 'vue-router'
import { store } from './store/index'
import App from './App.vue'
import BootstrapVue, { LayoutPlugin, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
import slVueTree from 'sl-vue-tree'
import './assets/css/gdq_web.css'
import './assets/css/gdqfont.css'
import './assets/custom.scss'
// ------------
// My GDQ Page
// ------------
import MyGDQPage from './components/MyGDQPage.vue'
import Profile from './components/Profile.vue'
import Surveys from './components/Surveys.vue'
import Checklist from './components/Checklist.vue'
import { config } from '../config'
// import MaintenanceMode from './components/MaintenanceMode'
// ------------------
// Fontawesome Icons
// ------------------
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
// Browser detection
import browserDetect from 'vue-browser-detect-plugin'
import routes from './routes'

Vue.use(browserDetect)
Vue.use(BootstrapVue)
Vue.use(LayoutPlugin)
Vue.use(BootstrapVueIcons)

// ------------
// Folder Tree
// ------------
Vue.component('sl-vue-tree', slVueTree)
Vue.component('fa-icon', Icon)

Vue.config.productionTip = false
const accessToken = localStorage.getItem('gdq_token')
if (accessToken) {
  axios.defaults.headers.common['Authorization'] = accessToken
}

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: routes
})
router.beforeEach((to, from, next) => {
  // console.log({ to, from, maintenancemode: config.maintenancemode })
  if (to.query.t) {
    store.dispatch('switchto', { token: to.query.t })
    store.dispatch('setadmin', { asadmin: 1 })
  }
  if (
    config.maintenancemode &&
    to.name != 'maintenancemode' &&
    to.name != 'gdqquestionnaire' &&
    to.name != 'apiquestionnaire' &&
    to.name != 'consultantmailpreferences' &&
    to.name != 'styleguide' &&
    store.state.asadmin != 1
  ) {
    next('/maintenancemode')
  } else {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (store.getters.isLoggedIn) {
        next()
        return
      }
      next('/login')
    } else {
      next()
    }
  }
})

new Vue({
  el: '#app',
  components: {
    App,
    MyGDQPage,
    Profile,
    Surveys,
    Checklist
  },
  template: '<App/>',
  store,
  router,
  browserDetect
})
